import {lazy, useEffect, useState} from "react";
import IntroContent from "../../content/IntroContent.json";
import UseCasesContent from "../../content/UseCasesContent.json";
import ExpandNetworkContent from "../../content/ExpandNetworkContent.json";
import BusinessNetworkContent from "../../content/BusinessNetworkContent.json";
import DiscoverGigsContent from "../../content/DiscoverGigsContent.json";
import BusinessGigsContent from "../../content/BusinessGigsContent.json";
import NewsletterContent from "../../content/NewsletterContent.json";
import ShowInterestContent from "../../content/ShowInterestContent.json";
import BusinessProjectManagementContent from "../../content/BusinessProjectManagementContent.json";
import ShareHighlightsContent from "../../content/ShareHighlightsContent.json";
import BusinessHighlightsContent from "../../content/BusinessHighlightsContent.json";
import AboutContent from "../../content/AboutContent.json";
import PlatformContent from "../../content/PlatformContent.json";
import { GradientCol } from "./styles";
import { HomeProps } from "./types";
import RequestAccessModal from "../../components/RequestAccessModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import Partners from "../../components/Partners";

const Newsletter = lazy(() => import("../../components/NewsletterForm"));
const Container = lazy(() => import("../../common/Container"));
const CarouselContainer = lazy(() => import("../../common/CarouselContainer"));
const AboutContainer = lazy(() => import("../../common/AboutContainer"));
const ScrollToTop = lazy(() => import("../../common/ScrollToTop"));
const ContentBlock = lazy(() => import("../../components/ContentBlock"));

const useHash = () => {
    const [hash, setHash] = useState(window.location.hash);

    useEffect(() => {
        const onHashChange = () => {
            setHash(window.location.hash);
        };

        window.addEventListener("hashchange", onHashChange);

        return () => {
            window.removeEventListener("hashchange", onHashChange);
        };
    }, []);

    return hash;
};

const Home = ({ defaultOpen = false, t, pilotProgram = false }: HomeProps) => {
  const [open, setOpen] = useState(defaultOpen);
  const [email, setEmail] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const hash = useHash();

  const showModal = () => {
    setOpen(true);
  };

    useEffect(() => {
        if (hash === "#request-access") {
            showModal();
        }
    }, [hash]);

  const [artistTabActive, setArtistTabActive] = useState(true);

  const selectTab = () => {
    setArtistTabActive(!artistTabActive);
  };

  const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const aboutContainerArtist = (
    <Container>
      <ContentBlock
        type="right"
        title={ExpandNetworkContent.title}
        subtitle={ExpandNetworkContent.subtitle}
        content={ExpandNetworkContent.text}
        icon="expand-network.svg"
        id="expand-network"
      />
      <ContentBlock
        type="left"
        title={DiscoverGigsContent.title}
        subtitle={DiscoverGigsContent.subtitle}
        content={DiscoverGigsContent.text}
        icon="discover-gigs.svg"
        id="discover-gigs"
      />
      <ContentBlock
        type="right"
        title={ShowInterestContent.title}
        subtitle={ShowInterestContent.subtitle}
        content={ShowInterestContent.text}
        icon="show-interest.svg"
        id="show-interest"
      />
      <ContentBlock
        type="left"
        title={ShareHighlightsContent.title}
        subtitle={ShareHighlightsContent.subtitle}
        content={ShareHighlightsContent.text}
        icon="share-highlights.svg"
        id="share-highlights"
      />
    </Container>
  );

  const aboutContainerBusiness = (
    <Container>
      <ContentBlock
        type="right"
        title={BusinessNetworkContent.title}
        subtitle={BusinessNetworkContent.subtitle}
        content={BusinessNetworkContent.text}
        icon="business-network.svg"
        id="business-network"
      />
      <ContentBlock
        type="left"
        title={BusinessGigsContent.title}
        subtitle={BusinessGigsContent.subtitle}
        content={BusinessGigsContent.text}
        icon="business-gigs.svg"
        id="business-gigs"
      />
      <ContentBlock
        type="right"
        title={BusinessProjectManagementContent.title}
        subtitle={BusinessProjectManagementContent.subtitle}
        content={BusinessProjectManagementContent.text}
        icon="business-project-management.svg"
        id="business-project-management"
      />
      <ContentBlock
        type="left"
        title={BusinessHighlightsContent.title}
        subtitle={BusinessHighlightsContent.subtitle}
        content={BusinessHighlightsContent.text}
        icon="business-highlights.svg"
        id="business-highlights"
      />
    </Container>
  );

  return (
    <>
      <ScrollToTop />
      <GradientCol />
      <Container>
        <ContentBlock
          type="right"
          title={IntroContent.title}
          subtitle={IntroContent.subtitle}
          content={IntroContent.text}
          icon="gradient"
          id="intro"
          showModal={showModal}
          email={email}
          handleChange={handleChangeEmail}
        />
        <ContentBlock
          type="center"
          title={UseCasesContent.title}
          subtitle={UseCasesContent.subtitle}
          content={UseCasesContent.text}
          section={UseCasesContent.section}
          id="use-cases"
        />
      </Container>
      <CarouselContainer>
        <Container>
          <ContentBlock
            type="carousel"
            title={PlatformContent.title}
            subtitle={PlatformContent.subtitle}
            content={PlatformContent.text}
            words={PlatformContent.words}
            id="platform"
            selectTab={selectTab}
            showModal={showModal}
          />
        </Container>
      </CarouselContainer>
      <AboutContainer
        title={AboutContent.title + (artistTabActive ? "artist" : "business")}
      >
        {artistTabActive ? aboutContainerArtist : aboutContainerBusiness}
      </AboutContainer>
      <Partners />
      <Container>
        <Newsletter
          title={NewsletterContent.title}
          content={NewsletterContent.text}
          id="newsletter"
        />
      </Container>
      <RequestAccessModal
        email={email}
        handleChangeEmail={handleChangeEmail}
        open={open}
        setOpen={setOpen}
        setOpenConfirmation={setOpenConfirmation}
        pilotProgram={pilotProgram}
      />
      <ConfirmationModal
        open={openConfirmation}
        setOpen={setOpenConfirmation}
        title="Request sent!"
        text="Thank you for your interest in joining Weavii! We're excited to have you onboard.
        You will receive an email from us when your request has been approved."
      />
    </>
  );
};

export default Home;
